import { createNamedContext } from '../utils/context';
import type { ThemeGroupContextValue, ThemeGroupSelectContextValue } from '../types';

/**
 * Context for managing theme group operations (select, edit, delete)
 * Provided by ThemeSelector component
 */
export const ThemeGroupContext = createNamedContext<ThemeGroupContextValue | undefined>(
  undefined,
  'ChartTheming.ThemeGroup.Context'
);

/**
 * Context for managing the dropdown menu visibility
 * Provided by Select.Input component
 */
export const ThemeGroupSelectContext = createNamedContext<ThemeGroupSelectContextValue | undefined>(
  undefined,
  'ChartTheming.ThemeGroupSelect.Context'
);
